<template>
  <div class="bar">
    <div class="bar-content flex">
      <div class="bar-logo flex-shrink">
        <!-- <img src="../assets/icon-lib-logo-foot.png"> -->
        <img style="width:auto;height:70px;" :src="clients.logoBottom">
      </div>
      <div class="flex-column bar-contact flex-shrink">
        <span class="font-color-white font-size-12 cursor" @click="toGuide">读者指南</span>
        <span class="font-color-white font-size-12 cursor" @click="toPotocal">服务条款</span>
        <span class="font-color-white font-size-12 cursor" data-type="feedback" @click="toWeb">咨询与反馈</span>
        <span class="font-color-white font-size-12 cursor" data-type="contact" @click="toWeb">联系我们</span>
      </div>

      <div class="flex-column bar-relateapp flex-shrink">
        <!-- <span class="font-color-white font-size-12">特藏展览应用平台</span>
        <span class="font-color-white font-size-12">多媒体专题库</span>
        <span class="font-color-white font-size-12">纪念册服务系统</span>
        <span class="font-color-white font-size-12">校园数字记忆</span> -->
      </div>

      <div class="flex-column bar-address flex-shrink">
        
        <span class="font-color-white font-size-12">{{clients.bottomInfo}}</span>
        <!-- <span class="font-color-white font-size-12">版权所有：爱迪科森 技术提供：爱迪科森</span>
        <span class="font-color-white font-size-12">技术支持与故障申告：400-8989-889，Email：service@bjadks.com</span>
        <span class="font-color-white font-size-12">投诉与建议：023-65106079</span>
        <span class="font-color-white font-size-12">北京市海淀区上地信息路1号上地国际创业园A栋1层，邮编：100085</span> -->
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api/home.js'
export default {
  data(){
    return{
      clients: this.$store.getters.application
    }
  },
  created() {
    let that =this;
    setTimeout(() => {
      that.clients = that.$store.getters.application  
    }, 1500);
  },
  methods: {
   
    toPotocal() {
      const routeData = this.$router.resolve({
        path: 'privacy',
        query: {
          t: 'potocal'
        }
      })
      window.open(routeData.href, '_blank')
    },
    toGuide() {
      const routeData = this.$router.resolve({
        path: 'privacy',
        query: {
          t: 'guide'
        }
      })
      window.open(routeData.href, '_blank')
    },
    toWeb(e) {
      const t = e.currentTarget.dataset.type
      if (t === 'feedback') {
        window.open('https://www.bjadks.com/Page/4-0-6.html', '_blank')
      } else if (t === 'contact') {
        window.open('https://www.bjadks.com/Page/4-30-6.html', '_blank')
      }
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>
<style scoped>
  .bar {
    width: 100%;
    height: 200px;
    background-color: #262A33;
    padding: 32px 0 0;
  }

  .bar-content {
    width: 1240px;
    height: 100%;
    margin: 0 auto;
  }

  .bar .bar-contact {
    margin-left: 98px;
    width: 96px;
  }

  .bar .bar-relateapp {
    margin-left: 72px;
    width: 132px;
  }

  .bar .bar-address {
    margin-left: 70px;
    width: 550px;
  }

  .bar .bar-contact span, .bar .bar-relateapp span{
    line-height: 24px;
    opacity: 0.8;
  }

  .bar-address span {
    line-height: 24px;
    opacity: 0.5;
  }

</style>
